import React, { FC } from 'react';
import Typography from '@mui/material/Typography';

import { IHierarchicalDepartmentDTO } from 'src/api/dtos';
import { Tooltip } from 'src/shared/components';
import { formatDepartmentDisplay } from 'src/shared/utils';

interface Props {
  department: IHierarchicalDepartmentDTO;
}

export const DepartmentSelectorOption: FC<Props> = ({ department }) => {
  return (
    <Tooltip
      title={formatDepartmentDisplay(department.description, department.number)}
      placement="left"
      showIcon={false}
    >
      <Typography fontSize="0.875rem" sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
        {formatDepartmentDisplay(department.description, department.number)}
      </Typography>
    </Tooltip>
  );
};
